export function OutlineMinusIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.013 10H5.01625C3.9108 10 3.01465 10.8951 3.01465 11.9992C3.01465 13.1033 3.9108 13.9984 5.01625 13.9984H19.013C20.1185 13.9984 21.0146 13.1033 21.0146 11.9992C21.0146 10.8951 20.1185 10 19.013 10Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
